import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { QuoteCardEntryGroup } from './quoteCardEntries'

export const CARD_PARAM = 'card'

interface QuoteCardEntryPickerProps {
  groups: QuoteCardEntryGroup[]
  selectedId: string
  onSelect: (id: string) => void
}

/** The side nav's stand-in below lg, where there is no room for the rail. */
export function QuoteCardEntryPicker({ groups, selectedId, onSelect }: QuoteCardEntryPickerProps) {
  return (
    <Select value={selectedId} onValueChange={onSelect}>
      <SelectTrigger aria-label="Quote card state" className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {groups.map((group, index) => (
          <SelectGroup key={group.label ?? index}>
            {group.label && <SelectLabel>{group.label}</SelectLabel>}
            {group.entries.map((entry) => (
              <SelectItem key={entry.id} value={entry.id}>
                {entry.carrier ? `${entry.state} · ${entry.carrier}` : entry.state}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  )
}
